import { ACCIONES_A_CONFIRMAR, ACCIONES_CRUD, SUSTANTIVOS_ACCIONES_A_CONFIRMAR } from '../utils/constantes';
import ConfirmacionAccion from '../components/ConfirmacionAccion.vue';
import { formatearErrores } from '../utils/funciones';

export default {
  components: {
    ConfirmacionAccion,
  },
  data() {
    return {
      items: [],
      pagina: 1,
      itemsPorPagina: Number(localStorage.getItem(`${this.$route.name}-itemsPorPagina`)) || 10,
      metadatos: null,
      cargando: false,
      accionesAConfirmar: ACCIONES_A_CONFIRMAR,
      sustantivosAccionesAConfirmar: SUSTANTIVOS_ACCIONES_A_CONFIRMAR,
      accionesCrud: ACCIONES_CRUD,
      confirmacion: {
        titulo: 'Acción a confirmar',
        mensaje: '¿Está seguro de realizar esta acción?',
        realizandoAccion: false,
        fnAceptar: () => {
          window.alert(`No se ha definido la función 'fnAceptar' en 'api-consumer.mixin.js'`);
        },
      },
      busqueda: null,
      retardo: null,
    };
  },
  methods: {
    async obtenerDatosMixin(fnServicio, llave, params = {}, callBackPre = null, callBackPost = null) {
      if (callBackPre) {
        callBackPre();
      }

      try {
        const { data } = await fnServicio({ params });
        const { datos } = data;

        this[llave] = datos;
      } catch (error) {
        const mensaje = error?.response ? error.response?.data?.mensaje : error.message;

        window.console.log(error);

        this[llave] = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      } finally {
        if (callBackPost) {
          callBackPost();
        }
      }
    },
    async obtenerDatosV2Mixin(fnServicio, llave, id, params = {}, callBackPre = null, callBackPost = null) {
      if (callBackPre) {
        callBackPre();
      }

      try {
        const { data } = await fnServicio(id, { params });
        const { datos } = data;

        this[llave] = datos;
      } catch (error) {
        const mensaje = error?.response ? error.response?.data?.mensaje : error.message;

        window.console.log(error);

        this[llave] = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      } finally {
        if (callBackPost) {
          callBackPost();
        }
      }
    },
    async obtenerDatosConNotificacion(fnServicioListar, llave, nombreRecurso, params = {}) {
      this.cargando = true;

      try {
        const { data } = await fnServicioListar({ params });
        const datos = data?.datos;
        const mensaje = data?.mensaje;

        this[llave] = datos;
        this.$notify({
          group: 'notifications',
          title: nombreRecurso.toUpperCase(),
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this[llave] = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    async guardarDatosMixin(
      fnServicioRegistrar,
      fnServicioEditar,
      accion,
      datos,
      nombreRecurso,
      callbackOk = null,
      callbackError = null,
      esFormData = false,
    ) {
      this.enviando = true;
      this.errores = [];

      try {
        let response = null;
        const id = esFormData ? datos.get('id') : datos.id;

        if (accion == this.accionesCrud.EDITAR) {
          response = await fnServicioEditar(id, datos);
        } else if (accion == this.accionesCrud.REGISTRAR) {
          response = await fnServicioRegistrar(datos);
        }

        this.$notify({
          group: 'notifications',
          title: nombreRecurso.toUpperCase(),
          text: response.data.mensaje,
          type: 'success',
        });

        if (callbackOk) {
          callbackOk();
        }
      } catch (error) {
        const data = error?.response?.data;
        const estado = error?.response?.status;
        const mensaje = data?.mensaje;
        const errores = data?.errores;
        const titulo = estado != 400 ? `${nombreRecurso.toUpperCase()}: ${mensaje}` : 'ERROR EN LA PETICIÓN';
        const erroresFormateados = formatearErrores(errores);

        if (callbackError) {
          callbackError(errores);
        }

        this.$notify({
          group: 'notifications',
          title: titulo,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.enviando = false;
      }
    },
    async getResponseAccion(accion) {
      return Promise.reject({
        response: { data: { mensaje: `No se ha definido la función 'getResponseAccion' para ${accion}` } },
      });
    },
    definirAccion(accion, nombreRecurso = 'Ítem') {
      return async () => {
        this.confirmacion.realizandoAccion = true;

        try {
          const response = await this.getResponseAccion(accion);
          const mensaje = response?.data?.mensaje;

          this.listar();
          this.$refs.confirmacionRef.cerrar();
          this.$notify({
            group: 'notifications',
            title: nombreRecurso.toUpperCase(),
            text: mensaje || 'Acción realizada con éxito',
            type: 'success',
          });
        } catch (error) {
          const mensaje = error?.response?.data?.mensaje;

          window.console.log(error);

          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: mensaje || error.message || 'Error al realizar la acción',
            type: 'error',
          });
        } finally {
          this.confirmacion.realizandoAccion = false;
        }
      };
    },
    confirmacionAccion(accion, nombreRecurso, identificadorRecurso = '') {
      if (
        ![
          this.accionesAConfirmar.ACTIVAR,
          this.accionesAConfirmar.DESACTIVAR,
          this.accionesAConfirmar.ELIMINAR,
        ].includes(accion)
      ) {
        return;
      }

      this.confirmacion.titulo = `${this.sustantivosAccionesAConfirmar[accion]} de ${nombreRecurso}`;
      this.confirmacion.mensaje = `¿Está seguro de ${accion} ${nombreRecurso.toLowerCase()} ${identificadorRecurso}?`;
      this.confirmacion.fnAceptar = this.definirAccion(accion, nombreRecurso);
      this.$refs.confirmacionRef.abrir();
    },
    async obtenerDatosPaginadosConNotificacion(fnServicioListar, llave, llaveMetadatos, nombreRecurso, params = {}) {
      this.cargando = true;

      try {
        const { data } = await fnServicioListar({ params });
        const { datos, mensaje, metadatos } = data;

        this[llave] = datos;
        this[llaveMetadatos] = metadatos;
        this.$notify({
          group: 'notifications',
          title: nombreRecurso.toUpperCase(),
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const mensaje = error?.response ? error.response?.data?.mensaje : error.message;

        window.console.log(error);

        this[llave] = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    listarRestableciendoPagina() {
      if (this.pagina != 1) {
        this.pagina = 1;
      }

      this.listar();
    },
    cambiarPagina() {
      this.listarRestableciendoPagina();

      localStorage.setItem(`${this.$route.name}-itemsPorPagina`, this.itemsPorPagina);
    },
    buscar(q) {
      clearTimeout(this.retardo);

      this.retardo = setTimeout(() => {
        this.busqueda = q;
        this.listarRestableciendoPagina();
      }, 500);
    },
  },
};
